module.exports = __webpack_public_path__ + "static/media/visit-to-unilag-02.0858b68c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Experience/Events/visit-to-unilag-02.jpg
// module id = 782
// module chunks = 0